import { styled } from '@slal/ui';
import { Accordion } from '@slal/ui/display';
import { breakpointDown, breakpointUp } from '@slal/ui/helpers';
import { Anchor } from '@slal/ui/navigation';
import { Li } from '@slal/ui/typography';
import { Card, DescriptionList } from '~/components';

export const ListItem = styled(Li)`
    color: black;
    margin-bottom: ${({ theme }) => theme.space[5]};
`;

export const StyledAccordion = styled(Accordion)`
    border: none;
    background: none;
    margin-bottom: ${({ theme }) => theme.space[4]};

    div {
        padding-left: 0;
    }

    h4 {
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    }
`;

const callToActionMaxWidth = '320px';

export const StyledActionLink = styled(Anchor)`
    display: block;
    margin-top: ${({ theme }) => theme.space[8]};
    ${breakpointUp.sm`
        max-width: ${callToActionMaxWidth};
    `}
`;

export const StyledEstimatedTimelines = styled(DescriptionList)`
    margin: 0;
    display: grid;
    grid-template-columns: 1fr;
    row-gap: ${({ theme }) => theme.space[3]};
    overflow: wrap;

    ${breakpointDown.xs`
        &:not(.no-hr) dd::after { 
            content: '';
            display: block;
            border-top: 1px solid ${({ theme }) => theme.colors.neutral__light__30};
            margin: ${({ theme }) => theme.space[5]} 0 0 0;
            width: 100%;
        }

        &:not(.no-hr) dd:last-of-type::after {
            content: none;
        }
    `}

    ${breakpointUp.sm`
        grid-template-columns: 52% 48%;
        row-gap: ${({ theme }) => theme.space[4]}; 

        dt {
            grid-column: 1 / 2;
            grid-row: span 2;
            align-self: start;
            padding-right: ${({ theme }) => theme.space[3]};
            white-space: nowrap;
        }

        dd {
            grid-column: 2 / 3;
            white-space: nowrap
        }

        &:not(.no-hr) dd::after {
            display: none;
        }
    `}
    
    dt {
        margin: 0;
    }

    dd {
        color: inherit;
        margin: 0 0 ${({ theme }) => theme.space[4]} 0;
        word-break: break-word;

        &:last-of-type {
            margin: 0;
        }
    }


    @media (min-width: 576px) and (max-width: 991px) {
        dd {
            grid-column: 1 / 3 !important; 
          }
`;

export const StyledNextStepsCard = styled(Card)`
    border-color: ${({ theme }) => theme.colors.blue__secondary__00};
    background-color: ${({ theme }) => theme.colors.blue__secondary__00};
    margin-bottom: ${({ theme }) => theme.space[6]};
`;
